define('behavior/button.search.input.behavior',['require','exports','module','underscore','marionette','uikit/uikit','uikit/extra/key.codes','backbone'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Mn       = require('marionette'),
      UIKit    = require('uikit/uikit'),
      KeyCodes = require('uikit/extra/key.codes'),
      Backbone = require('backbone');

  var ButtonSearchResults = UIKit.SearchResults.extend({

    updateEmptyProperty: function() {
      this.empty = !this.collection || this.collection.isEmpty();
      this.trigger('search:results:empty', this.empty);
    }


  });

  var ButtonSearchInputBehavior = Mn.Behavior.extend({
    defaults: {
      queryFields: [],
      onResultSelected: null,
      autocompleteCollection: null,
      autocompleteDropdownBindings: {
        text: 'name',
      },
      wildcardPrefix: '*',
      wildcardSuffix: '*',
      searchResultsView: ButtonSearchResults,
      resultsViewVisible: false,
      disclosureOwnerUserId: null,
    },

    hasBeenSelected: false,

    initialize: function() {
      var searchResultsView = this.getOption('searchResultsView');

      Mn.Behavior.prototype.initialize.apply(this, arguments);
      this.queryFields = this.getOption('queryFields');
      this.autocompleteCollection = this.getOption('autocompleteCollection');

      //if no search fields or an autocomplete collection have been configured, default to normal input element behavior
      if (_.isEmpty(this.queryFields) || _.isNull(this.autocompleteCollection)) {
        return;
      }

      this.view.resultsView = new searchResultsView();

      this.listenTo(this.autocompleteCollection, 'sync', function() {
        this.view.button.loading = false;
      });

      this.listenTo(this.view.resultsView, 'search:results:empty', this.handleEmptyResults);

      this.listenTo(this.view, 'button:press', this.handleButtonPress)
        .listenTo(this.view, 'focus', this.handleFocus)
        .listenTo(this.view, 'typeahead:blur', this.handleBlur)
        .listenTo(this.view, 'enter', this.handleEnterKey)
        .listenTo(this.view, 'typeahead:key:down', this.handleKeydown)
        .listenTo(this.view.resultsView, 'result:selected', this.onItemSelected);
    },

    handleFocus: function() {
      this.view.icon = '';
    },

    handleBlur: function() {
      this.clearSuggestions();
    },

    handleButtonPress: function() {
      if (!!this.view.value) {
        this.view.button.loading = true;
        this.onChangeSearchValue(this.view.value);
      }


    },

    handleEnterKey: function() {
      if (!this.resultsViewVisible) {
        // if there are no results available, treat the enter key like a button click,
        // otherwise it's necessary for keyboard management of the results view
        this.handleButtonPress();
      }
    },

    handleEmptyResults: function(isEmpty) {
      this.resultsViewVisible = !isEmpty;

      if (isEmpty) {
        this.view.button.loading = false;
      }
    },

    handleKeydown: function(keycode) {
      var resultsView = this.view.resultsView;

      if (keycode === KeyCodes.DOWNARROW_KEY) {
        resultsView.selectNextResult();
      } else if (keycode === KeyCodes.UPARROW_KEY) {
        resultsView.selectPreviousResult();
      } else if (!resultsView.empty && (keycode === KeyCodes.ENTER_KEY || keycode === KeyCodes.TAB_KEY)) {
        selected = resultsView.getSelected();
        this.onItemSelected(selected);
      } else if (keycode === KeyCodes.ESCAPE_KEY) {
        this.setInputValue(this.view.value);
        this.clearSuggestions();
      }
    },

    onItemSelected: function(result) {
      //prettier-ignore
      var valueAttribute = this.getOption('autocompleteDropdownBindings').text,
          onResultSelected = this.getOption('onResultSelected');

      this.hasBeenSelected = true;
      this.clearSuggestions();

      if (onResultSelected) {
        onResultSelected(result, this);
      }
      this.setInputValue(result.model.get(valueAttribute));
      this.view.icon = 'green check';

      this.view.trigger('typeahead:item:selected', this.view, result);
    },

    onChangeSearchValue: function(value) {
      //prettier-ignore
      var collection,
        autocompleteDropdownBindings;

      collection = this.getAutocompleteCollection(value);
      autocompleteDropdownBindings = this.getOption('autocompleteDropdownBindings');
      this.setAutocompleteDropdownViewCollection(collection, autocompleteDropdownBindings);

    },

    getEmptyValue: function() {
      return this.view.getOption('saveEmptyStringAsNull') ? null : '';
    },

    setInputValue: function(value) {
      if (value) {
        this.hasBeenSelected = true;
      }
      this.originalValue = value;
      this.view.ui.input.val(value);
      this.view.value = value;

      this.view.trigger('typeahead:input:value', this.view, value);
    },

    setTraditionalAPIFilters: function(autocompleteCollection, value) {
      //prettier-ignore
      var fieldName        = this.getOption('autocompleteDropdownBindings').text,
          wildcardPrefix   = this.getOption('wildcardPrefix'),
          wildcardSuffix   = this.getOption('wildcardSuffix'),
          disclosureOwnerUserId = this.getOption('disclosureOwnerUserId'),
          queryFields      = this.getOption('queryFields');

      // reset the filters
      autocompleteCollection.filters.reset();
      // add in any defined query parameters
      _.each( queryFields, function(name) {
        autocompleteCollection.filters.add(this.createFilterObject(value, name, wildcardPrefix, wildcardSuffix));
      }, this );
      // add in a filter for disclosureOwnerId
      autocompleteCollection.filters.add(this.createFilterObject(disclosureOwnerUserId, 'disclosureOwnerUserId', '', ''));

      return autocompleteCollection;
    },


    setAutocompleteCollectionFilters: function(value) {
      //prettier-ignore
      var fieldName   = this.getOption('autocompleteDropdownBindings').text,
          queryFields = this.getOption('queryFields');

      this.disclosureOwnerUserId = this.view.model.parentRelationship.foreignModel.attributes.disclosureOwnerUserId;

      this.setTraditionalAPIFilters(this.autocompleteCollection, value);
      this.autocompleteCollection.sort.field('lastName').makeAscending();
      this.autocompleteCollection
        .fetch()
        .promise()
        .bind(this)
        .then(function(resp) {
          resp.sort(function(a, b) {
            aName = a.lastName + ', ' + a.firstName;
            bName = b.lastName + ', ' + b.firstName;

            if (aName < bName) {
              return -1
            }
            if (aName > bName) {
              return 1
            }
            return 0;
          });

          return resp;
        });

      return this.autocompleteCollection;
    },

    getAutocompleteCollection: function(value) {
      this.setAutocompleteCollectionFilters(value);

      return this.autocompleteCollection;
    },

    createFilterObject: function(value, field, wildcardPrefix, wildcardSuffix) {
      return {
        field: field,
        value: wildcardPrefix + value + wildcardSuffix,
      };
    },

    setAutocompleteDropdownViewCollection: function(collection, bindings) {

      this.view.resultsView.childBindings = bindings;
      this.view.resultsView.collection = collection;

    },

    clearSuggestions: function() {
      if (!this.view.resultsView.empty) {
        this.view.resultsView.collection.reset();
      }
    },
  });
  module.exports = ButtonSearchInputBehavior;
});

